import { createFileRoute } from '@tanstack/react-router';

import { CallPoolScreen } from '@/features/telephony/components/CallPoolScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/workspace/telephony/')({
  beforeLoad: () => {
    requirePermission('telephony:read');
  },
  // Admin surface: view-only pool; claimed calls open in the workspace.
  component: WorkspaceCallPoolRoute,
  staticData: { crumb: 'Calls' },
});

function WorkspaceCallPoolRoute() {
  return <CallPoolScreen surface="workspace" />;
}
